import { groupByTrack } from "../utils";
import {
  CameraProjection,
  CameraProjectionTrackSnapshot,
  DetectionSnapshot,
  DetectionsSnapshotResult,
  Snapshot,
  SnapshotResponseBase,
  TrackSnapshotResult,
} from "@/shared/types";
import { TracksBufferLoader } from "./track-buffer-loader";
import { insightsApiInstance } from "@/shared/api/axios";

export const createTrackSnapshotsBufferLoader = () =>
  new TracksBufferLoader<Snapshot>({
    queryFn: async ({ fromDateTime, toDateTime, page, limit, signal }) => {
      const apiClient = insightsApiInstance;
      const response = await apiClient.get<TrackSnapshotResult>(
        "/track/snapshots/",
        {
          params: {
            from_datetime: fromDateTime,
            ...(toDateTime
              ? {
                  to_datetime: toDateTime,
                }
              : {}),
            page,
            limit,
          },
          signal: signal?.signal,
        }
      );

      return response.data;
    },
  });

export const createDetectionBufferLoader = () =>
  new TracksBufferLoader<DetectionSnapshot>({
    queryFn: async ({
      fromDateTime,
      toDateTime,
      page,
      limit,
      cameraIds,
      signal,
    }) => {
      const response = await insightsApiInstance.get<DetectionsSnapshotResult>(
        "/track/detections/",
        {
          params: {
            from_datetime: fromDateTime,
            ...(toDateTime
              ? {
                  to_datetime: toDateTime,
                }
              : {}),
            camera_ids: cameraIds,
            page,
            limit,
          },
          signal: signal?.signal,
        }
      );

      return {
        ...response.data,
        results: groupByTrack(response.data.results),
      } as SnapshotResponseBase<DetectionSnapshot>;
    },
  });

export const createReprojectionsBufferLoader = () =>
  new TracksBufferLoader<CameraProjectionTrackSnapshot>({
    queryFn: async ({
      fromDateTime,
      toDateTime,
      page,
      limit,
      cameraIds,
      signal,
    }) => {
      const response = await insightsApiInstance.get<CameraProjection>(
        `/track/camera/${cameraIds}/projections/`,
        {
          params: {
            from_datetime: fromDateTime,
            ...(toDateTime
              ? {
                  to_datetime: toDateTime,
                }
              : {}),
            camera_ids: cameraIds,
            page,
            limit,
          },
          signal: signal?.signal,
        }
      );

      return {
        ...response.data,
        results: groupByTrack(response.data.results),
      } as SnapshotResponseBase<CameraProjectionTrackSnapshot>;
    },
  });
